import { apiRequest, buildUrlWithParams } from "./api-client";

export async function getMovements(
  shopId: string,
  filters?: {
    page?: number;
    limit?: number;
    search?: string;
    type?: string;
    status?: string;
    startDate?: string;
    endDate?: string;
    supplierId?: string;
  },
): Promise<{ movements: any[]; total: number }> {
  const url = buildUrlWithParams(
    `/api/shops/${shopId}/inventory/movements`,
    filters as Record<string, string | number | undefined>,
  );
  return apiRequest(url);
}

export async function getMovementStats(
  shopId: string,
  params?: { startDate?: string; endDate?: string },
): Promise<{
  totalEntries: number;
  totalExits: number;
  totalWaste: number;
  entriesQuantity: number;
  exitsQuantity: number;
  entriesCost: number;
  exitsCost: number;
  wasteCost: number;
}> {
  const url = buildUrlWithParams(
    `/api/shops/${shopId}/inventory/movements/stats`,
    params as Record<string, string | undefined>,
  );
  return apiRequest(url);
}

export async function getMovementDetail(
  shopId: string,
  id: string,
): Promise<any> {
  return apiRequest(`/api/shops/${shopId}/inventory/movements/${id}`);
}

export async function createEntry(
  shopId: string,
  data: {
    supplierId?: string;
    referenceType?: string;
    referenceNumber?: string;
    notes?: string;
    status?: string;
    registeredById?: string;
    confirmedById?: string;
    lines: {
      inventoryId: string;
      productId: string;
      quantity: number;
      unitCost: string;
      batchNumber?: string;
      expiryDate?: string;
      manufactureDate?: string;
    }[];
  },
): Promise<any> {
  return apiRequest(`/api/shops/${shopId}/inventory/movements/entry`, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function createExit(
  shopId: string,
  data: {
    type: "exit" | "waste" | "adjustment";
    referenceType?: string;
    referenceNumber?: string;
    notes?: string;
    status?: string;
    registeredById?: string;
    lines: {
      inventoryId: string;
      productId: string;
      quantity: number;
      unitCost?: string;
      batchNumber?: string;
    }[];
  },
): Promise<any> {
  return apiRequest(`/api/shops/${shopId}/inventory/movements/exit`, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function createAdjustment(
  shopId: string,
  data: {
    inventoryId: string;
    productId: string;
    physicalStock: number;
    reason: string;
    notes?: string;
    registeredById?: string;
  },
): Promise<any> {
  return apiRequest(`/api/shops/${shopId}/inventory/movements/adjustment`, {
    method: "POST",
    body: JSON.stringify(data),
  });
}

export async function cancelMovement(
  shopId: string,
  id: string,
): Promise<void> {
  return apiRequest(`/api/shops/${shopId}/inventory/movements/${id}/cancel`, {
    method: "POST",
  });
}
